export default "__VITE_ASSET__$uNTtjKJ__"